// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-callback-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem 1rem;
}
.payment-callback-page .callback-container {
  max-width: 600px;
  width: 100%;
  background: white;
  border-radius: 20px;
  padding: 3rem 2rem;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  text-align: center;
}
.payment-callback-page .loading-state {
  padding: 2rem 0;
}
.payment-callback-page .loading-state h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2c3e50;
}
.payment-callback-page .loading-state p {
  font-size: 0.95rem;
  margin-top: 0.5rem;
}
.payment-callback-page .icon-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin-bottom: 1.5rem;
  animation: scaleIn 0.5s ease-out;
}
.payment-callback-page .icon-container svg {
  stroke-width: 2;
}
.payment-callback-page .icon-container.success {
  background: rgba(40, 167, 69, 0.1);
  color: #28a745;
}
.payment-callback-page .icon-container.failure {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}
.payment-callback-page .icon-container.error {
  background: rgba(255, 193, 7, 0.1);
  color: #ffc107;
}
.payment-callback-page .status-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #2c3e50;
}
.payment-callback-page .status-message {
  font-size: 1.1rem;
  color: #6c757d;
  margin-bottom: 2rem;
  line-height: 1.6;
}
.payment-callback-page .transaction-details {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
}
.payment-callback-page .transaction-details .detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid #e9ecef;
}
.payment-callback-page .transaction-details .detail-row:last-child {
  border-bottom: none;
}
.payment-callback-page .transaction-details .detail-row .detail-label {
  font-weight: 600;
  color: #495057;
  font-size: 0.9rem;
}
.payment-callback-page .transaction-details .detail-row .detail-value {
  font-weight: 500;
  color: #212529;
  font-size: 0.95rem;
  font-family: "Courier New", monospace;
}
.payment-callback-page .success-actions,
.payment-callback-page .failure-actions,
.payment-callback-page .error-actions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
}
.payment-callback-page .success-actions .btn,
.payment-callback-page .failure-actions .btn,
.payment-callback-page .error-actions .btn {
  border-radius: 10px;
  padding: 0.75rem 2rem;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
}
.payment-callback-page .success-actions .btn:hover,
.payment-callback-page .failure-actions .btn:hover,
.payment-callback-page .error-actions .btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.payment-callback-page .failure-actions,
.payment-callback-page .error-actions {
  flex-direction: row;
  justify-content: center;
}
@media (max-width: 576px) {
  .payment-callback-page .failure-actions,
  .payment-callback-page .error-actions {
    flex-direction: column;
  }
}
.payment-callback-page .success-footer {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e9ecef;
}
.payment-callback-page .success-footer p {
  font-size: 1.1rem;
  color: #667eea;
  font-weight: 500;
  margin: 0;
}
.payment-callback-page .alert {
  text-align: left;
  display: flex;
  align-items: center;
  border-radius: 10px;
}
.payment-callback-page .alert svg {
  flex-shrink: 0;
}

@keyframes scaleIn {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
@media (max-width: 768px) {
  .payment-callback-page {
    padding: 1rem;
  }
  .payment-callback-page .callback-container {
    padding: 2rem 1.5rem;
  }
  .payment-callback-page .status-title {
    font-size: 1.5rem;
  }
  .payment-callback-page .status-message {
    font-size: 1rem;
  }
  .payment-callback-page .icon-container {
    width: 100px;
    height: 100px;
  }
  .payment-callback-page .icon-container svg {
    width: 60px;
    height: 60px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Student/PaymentForm/PaymentCallback.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6DAAA;EACA,kBAAA;AACF;AACE;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;EACA,kBAAA;AACJ;AAEE;EACE,eAAA;AAAJ;AAEI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AAAN;AAGI;EACE,kBAAA;EACA,kBAAA;AADN;AAKE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,gCAAA;AAHJ;AAKI;EACE,eAAA;AAHN;AAMI;EACE,kCAAA;EACA,cAAA;AAJN;AAOI;EACE,kCAAA;EACA,cAAA;AALN;AAQI;EACE,kCAAA;EACA,cAAA;AANN;AAUE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AARJ;AAWE;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AATJ;AAYE;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAVJ;AAYI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;AAVN;AAYM;EACE,mBAAA;AAVR;AAaM;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;AAXR;AAcM;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,qCAAA;AAZR;AAiBE;;;EAGE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAfJ;AAiBI;;;EACE,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAbN;AAeM;;;EACE,2BAAA;EACA,0CAAA;AAXR;AAgBE;;EAEE,mBAAA;EACA,uBAAA;AAdJ;AAgBI;EALF;;IAMI,sBAAA;EAZJ;AACF;AAeE;EACE,gBAAA;EACA,mBAAA;EACA,6BAAA;AAbJ;AAeI;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;AAbN;AAiBE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,cAAA;AAfN;;AAoBA;EACE;IACE,mBAAA;IACA,UAAA;EAjBF;EAmBA;IACE,mBAAA;IACA,UAAA;EAjBF;AACF;AAqBA;EACE;IACE,aAAA;EAnBF;EAqBE;IACE,oBAAA;EAnBJ;EAsBE;IACE,iBAAA;EApBJ;EAuBE;IACE,eAAA;EArBJ;EAwBE;IACE,YAAA;IACA,aAAA;EAtBJ;EAwBI;IACE,WAAA;IACA,YAAA;EAtBN;AACF","sourcesContent":[".payment-callback-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 2rem 1rem;\n\n  .callback-container {\n    max-width: 600px;\n    width: 100%;\n    background: white;\n    border-radius: 20px;\n    padding: 3rem 2rem;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n    text-align: center;\n  }\n\n  .loading-state {\n    padding: 2rem 0;\n\n    h2 {\n      font-size: 1.5rem;\n      font-weight: 600;\n      color: #2c3e50;\n    }\n\n    p {\n      font-size: 0.95rem;\n      margin-top: 0.5rem;\n    }\n  }\n\n  .icon-container {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    margin-bottom: 1.5rem;\n    animation: scaleIn 0.5s ease-out;\n\n    svg {\n      stroke-width: 2;\n    }\n\n    &.success {\n      background: rgba(40, 167, 69, 0.1);\n      color: #28a745;\n    }\n\n    &.failure {\n      background: rgba(220, 53, 69, 0.1);\n      color: #dc3545;\n    }\n\n    &.error {\n      background: rgba(255, 193, 7, 0.1);\n      color: #ffc107;\n    }\n  }\n\n  .status-title {\n    font-size: 2rem;\n    font-weight: 700;\n    margin-bottom: 1rem;\n    color: #2c3e50;\n  }\n\n  .status-message {\n    font-size: 1.1rem;\n    color: #6c757d;\n    margin-bottom: 2rem;\n    line-height: 1.6;\n  }\n\n  .transaction-details {\n    background: #f8f9fa;\n    border-radius: 12px;\n    padding: 1.5rem;\n    margin-bottom: 2rem;\n\n    .detail-row {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 0.75rem 0;\n      border-bottom: 1px solid #e9ecef;\n\n      &:last-child {\n        border-bottom: none;\n      }\n\n      .detail-label {\n        font-weight: 600;\n        color: #495057;\n        font-size: 0.9rem;\n      }\n\n      .detail-value {\n        font-weight: 500;\n        color: #212529;\n        font-size: 0.95rem;\n        font-family: 'Courier New', monospace;\n      }\n    }\n  }\n\n  .success-actions,\n  .failure-actions,\n  .error-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin-top: 2rem;\n\n    .btn {\n      border-radius: 10px;\n      padding: 0.75rem 2rem;\n      font-weight: 600;\n      font-size: 1rem;\n      transition: all 0.3s ease;\n\n      &:hover {\n        transform: translateY(-2px);\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n      }\n    }\n  }\n\n  .failure-actions,\n  .error-actions {\n    flex-direction: row;\n    justify-content: center;\n\n    @media (max-width: 576px) {\n      flex-direction: column;\n    }\n  }\n\n  .success-footer {\n    margin-top: 2rem;\n    padding-top: 1.5rem;\n    border-top: 1px solid #e9ecef;\n\n    p {\n      font-size: 1.1rem;\n      color: #667eea;\n      font-weight: 500;\n      margin: 0;\n    }\n  }\n\n  .alert {\n    text-align: left;\n    display: flex;\n    align-items: center;\n    border-radius: 10px;\n\n    svg {\n      flex-shrink: 0;\n    }\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    transform: scale(0);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .payment-callback-page {\n    padding: 1rem;\n\n    .callback-container {\n      padding: 2rem 1.5rem;\n    }\n\n    .status-title {\n      font-size: 1.5rem;\n    }\n\n    .status-message {\n      font-size: 1rem;\n    }\n\n    .icon-container {\n      width: 100px;\n      height: 100px;\n\n      svg {\n        width: 60px;\n        height: 60px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
